import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Log detallado para errores 400 en usuarios
      if (error.status === 400 && req.url.includes('/api/users/')) {
        console.error('🚨 [ErrorInterceptor] 400 Bad Request Details:');
        console.error('🚨 URL:', req.url);
        console.error('🚨 Method:', req.method);
        console.error('🚨 Request Body:', req.body);
        console.error('🚨 Response Error:', error.error);
        console.error('🚨 Full Error:', error);
      }

      return throwError(() => error);
    })
  );
};
